"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_DamageReciprocationEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
let Effect_DamageReciprocationEventHandlerScript = class Effect_DamageReciprocationEventHandlerScript {
    run(sequence, container, handler, event) {
        container.applyExactDamage({
            sequence,
            attackerId: event.subject,
            targetId: event.args.attackerId,
            damage: handler.args.scriptArgs.damageToReciprocate
        });
    }
};
Effect_DamageReciprocationEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_DamageReciprocation")
], Effect_DamageReciprocationEventHandlerScript);
exports.Effect_DamageReciprocationEventHandlerScript = Effect_DamageReciprocationEventHandlerScript;
